export const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
];



// WEBPACK FOOTER //
// ./src/utils/constants.tsx